import React, { useEffect, useState } from 'react'
import Layout from '../../../components/common/pageLayout'
import Form from '../../../components/SiteManagement/Print/FatReport/index'
import { v2_yards } from '../../../actions/v2/masterData';
import { v2_ships } from '../../../actions/v2/projectAndVessel';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { toast } from 'react-toastify';
import { v3_fetchFatReportFormFields, } from '../../../actions/v3/siteManagement';

const FatReport = (props) => {
    const { data } = props;

    const [commonDetails, setCommonDetails] = useState({
        ship: { value: '', options: [], error: '' },
        date: { value: '', error: '' },
        finalSubmit: { value: false },
        yard: { value: '', options: [] },
    });

    const [state, setState] = useState({
        witnessManufacturer: { name: 'witnessManufacturer', value: '', error: '', isRequired: false },
        witnessShipyard: { name: 'witnessShipyard', value: '', error: '', isRequired: false },
        witnessCompany: { name: 'witnessCompany', value: '', error: '', isRequired: false },
        witnessOwner: { name: 'witnessOwner', value: '', error: '', isRequired: false },
        reportedBy: { name: 'reportedBy', value: '', error: '', isRequired: false },
        placeOfInspection: { name: 'placeOfInspection', value: '', error: '', isRequired: false },
        dateOfInspection: { name: 'dateOfInspection', value: '', error: '', isRequired: false },
        result: { name: 'result', value: '', error: '', isRequired: false },
        itemOfInspectionResultAndProblem: { name: 'itemOfInspectionResultAndProblem', value: '', error: '', isRequired: false },
        comment: { name: 'comment', value: '', error: '', isRequired: false },
        feedback: { name: 'feedback', value: '', error: '', isRequired: false },

    });

    const [photoState, setPhotoState] = useState([{ file: "", new: true }]);
    const [documentState, setDocumentState] = useState([{ file: "", new: true }]);


    const [showLoader, setShowLoader] = useState(false);




    // Load yards
    useEffect(() => {
        v2_yards().then((res) => {
            if (res.status) {
                setCommonDetails((prev) => ({
                    ...prev,
                    yard: { ...prev.yard, options: res.result },
                }));
            }
        });
    }, []);

    // Load ships when yard changes
    useEffect(() => {
        if (commonDetails.yard.value) {
            v2_ships(null, null, commonDetails.yard.value).then((res) => {
                if (res.status) {
                    setCommonDetails((prev) => ({
                        ...prev,
                        ship: { ...prev.ship, options: res.result },
                    }));
                }
            });
        } else {
            setCommonDetails((prev) => ({
                ...prev,
                ship: { value: '', options: [] },
            }));
        }
    }, [commonDetails.yard.value]);

    useEffect(() => {
        const params = data 

        if (params) {
            setShowLoader(true);

            v3_fetchFatReportFormFields(params.FORM_ID)
                .then((res) => {
                    if (res.status) {
                        const { records, photos, documents, commonDetails } = res.result;

                        if (params.FORM_ID) {
                            // ✅ Common Details
                            setCommonDetails((prev) => ({
                                ...prev,
                                yard: { ...prev.yard, value: commonDetails?.YARD_ID || '' },
                                ship: { ...prev.ship, value: commonDetails?.SHIP_ID || '' },
                                date: { ...prev.date, value: commonDetails?.DATE || '' },
                                finalSubmit: { ...prev.finalSubmit, value: Boolean(commonDetails?.FINAL_SUBMITTED) },
                            }));

                            // ✅ Records
                            setState((prev) => ({
                                ...prev,
                                witnessManufacturer: { ...prev.witnessManufacturer, value: records?.WITNESS_MANUFACTURER || '' },
                                witnessShipyard: { ...prev.witnessShipyard, value: records?.WITNESS_SHIPYARD || '' },
                                witnessCompany: { ...prev.witnessCompany, value: records?.WITNESS_COMPANY || '' },
                                witnessOwner: { ...prev.witnessOwner, value: records?.WITNESS_OWNER || '' },
                                reportedBy: { ...prev.reportedBy, value: records?.REPORTED_BY || '' },
                                dateOfInspection: { ...prev.dateOfInspection, value: records?.DATE_OF_INSPECTION || '' },
                                placeOfInspection: { ...prev.placeOfInspection, value: records?.PLACE_OF_INSPECTION || '' },
                                result: { ...prev.result, value: records?.RESULT || '' },
                                itemOfInspectionResultAndProblem: {
                                    ...prev.itemOfInspectionResultAndProblem,
                                    value: records?.ITEM_OF_INSPECTION_RESULT_AND_PROBLEM || ''
                                },
                                comment: { ...prev.comment, value: records?.COMMENT || '' },
                                feedback: { ...prev.feedback, value: records?.FEEDBACK || '' },
                            }));

                            // ✅ Photos (already uploaded → new: false)
                            setPhotoState(
                                (photos || []).map((p) => ({
                                    id: p.ID,
                                    file: p.ORIGINAL_NAME,
                                    new: false,   // important!
                                }))
                            );

                            // ✅ Documents (already uploaded → new: false)
                            setDocumentState(
                                (documents || []).map((d) => ({
                                    id: d.ID,
                                    file: d.ORIGINAL_NAME,
                                    new: false,   // important!
                                }))
                            );
                        }
                    } else {
                        toast.error(res.error || "Error fetching FAT Report data");
                    }
                })
                .catch(() => {
                    toast.error("Something went wrong while fetching.");
                })
                .finally(() => {
                    setShowLoader(false);
                });
        }
    }, []);



    return (
        <Layout
            title={'FAT Report'}
        >
            <div className="row">
                <div className="col-lg-12">
                    <div className="card" id={1}>
                        <div className="card-body">
                            <div className="checklist-title-bx">
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="text-center">
                                            <h4>Factory Acceptance Test Report</h4>
                                            <p>
                                                Following to be checked and confirmed before official delivery
                                                of the vessel
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12 ">
                                    <div className="report-index-top">
                                        <table>
                                            <tbody>
                                                <tr>
                                                    <td className="hd-s2 w150">
                                                        <p>Yard</p>
                                                    </td>
                                                    <td className="td-input-bx">
                                                        <div className="hull-select-box">
                                                            <select
                                                                className="form-select"
                                                                value={commonDetails.yard.value}
                                                                disabled={data ? true : false}
                                                                onChange={(e) =>
                                                                    setCommonDetails((prev) => ({
                                                                        ...prev,
                                                                        yard: { ...prev.yard, value: e.target.value },
                                                                    }))
                                                                }
                                                            >

                                                                <option value={''}>Select Yard</option>
                                                                {commonDetails.yard.options.map((item) => {
                                                                    return (<option value={item.ID}> {item.YARD_NAME}</option>)
                                                                })}
                                                            </select>
                                                        </div>
                                                    </td>
                                                    <td className="hd-s2 pl10 w150">
                                                        <p>Hull No</p>
                                                    </td>
                                                    <td className="td-input-bx">
                                                        <div className="hull-select-box">
                                                            <select
                                                                className="form-select"
                                                                disabled={data ? true : false}
                                                                value={commonDetails.ship.value}
                                                                onChange={(e) => {
                                                                    setCommonDetails((prev) => ({
                                                                        ...prev,
                                                                        ship: { ...prev.ship, value: e.target.value }
                                                                    }));
                                                                }}


                                                            >

                                                                <option value={''}>Select Hull</option>
                                                                {commonDetails.ship.options.map((item) => {
                                                                    return (<option value={item.ID}>{item.HULL_NUMBER} - {item.SHIP_NAME}</option>)
                                                                })}
                                                            </select>
                                                        </div>
                                                    </td>
                                                    <td className="hd-s2 w150">
                                                        <p>Date</p>
                                                    </td>
                                                    <td className="td-input-bx">
                                                        <td className="">
                                                            <input
                                                                type="date"
                                                                className="form-control"
                                                                value={commonDetails.date.value}
                                                                onChange={(e) =>
                                                                    setCommonDetails((prev) => ({
                                                                        ...prev,
                                                                        date: { ...prev.date, value: e.target.value },
                                                                    }))
                                                                }
                                                            />
                                                        </td>
                                                    </td>
                                                </tr>

                                            </tbody>
                                        </table>
                                    </div>

                                </div>
                            </div>
                            <Form
                                state={state}
                                isFinalSubmitting={commonDetails.finalSubmit.value}


                                photoState={photoState}
                                documentState={documentState}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    )
}

export default FatReport